import React from 'react';
import { Box, Button, TextField, InputAdornment, useMediaQuery } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CustomSelectDropdown from '../../../../../components/CustomSelectDropDown';
import GlobalSearch from '../../../../../components/Search';
import PrimaryButton from '../../../../../components/Button/Button';
import { useCustomParams } from '../../../../../hooks/useCustomParams';

const Filters = ({ statusCounts }) => {
  const isMobile = useMediaQuery("(max-width:690px)");
  const [status, updateStatus] = useCustomParams("status");
  const filterButtons = [
    { label: "Total", value: "all", total: statusCounts?.total || 0 },
    { label: "Pending", value: "pending", total: statusCounts?.pending || 0 },
    {
      label: "Doc's Req'd",
      value: "docs_required",
      total: statusCounts?.docs_required || 0,
    },
    {
      label: "Submitted",
      value: "submitted",
      total: statusCounts?.submitted || 0,
    },

    {
      label: "Removed",
      value: "vio_removed",
      total: statusCounts?.vio_removed || 0,
    },
    {
      label: "Rejected",
      value: "rejected",
      total: statusCounts?.rejected || 0,
    },
    { label: "Overdue", value: "overdue", total: statusCounts?.overdue || 0 },
    {
      label: "Request Dismissal",
      value: "req_dismissal",
      total: statusCounts?.req_dismissal || 0,
    },
  ];

  const dropdownOptions = filterButtons.map((btn) => ({
    label: `${btn.label} ${btn.total}`,
    value: btn.value,
  }));

  return (
    <Box className="hpd-violations-filters bg-white">
      <Box className="filter-buttons">
        {isMobile ? (
          <CustomSelectDropdown
            options={dropdownOptions}
            label="Filter by Status"
            onSelectChange={(value) => updateStatus("status", value)}
            defaultValue={status}
          />
        ) : (
          filterButtons.map((btn, idx) => (
            <PrimaryButton
              variant="contained"
              key={idx}
              className={`capitalize violation-filter-btn ${
                btn.value === status ? "btn-bg-grey" : "btn-bg-light-grey"
              }`}
              onClick={() => updateStatus("status", btn.value)}
            >
              {btn.label}{" "}
              <span
                className={`${
                  btn.value === status ? "survey-count-select" : "survey-count"
                }`}
              >{` ${btn.total}`}</span>
            </PrimaryButton>
          ))
        )}
      </Box>
      <GlobalSearch name="search" />
    </Box>
  );
};

export default Filters; 